var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"h4"},[_vm._v(_vm._s(_vm.title))]),_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb pl-0"},[_c('li',{staticClass:"breadcrumb-item"},[_vm._v("IT Inventory")]),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v(_vm._s(_vm.subtitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }